import { useEffect } from 'react'
import { AppLayout } from '@/components/layout/AppLayout'
import { useMobileDetection } from '@/hooks/useMobileDetection'
import { useSelectionHistory } from '@/hooks/useSelectionHistory'
import { useSelectionPersistence } from '@/hooks/useSelectionPersistence'
// import MapService from '@/services/arcgis/MapServiceFacade'
// import type { WardInfo } from '@/types/ward'
import { useWardStore } from '@/stores/wardStore'
import { useUIStore } from '@/stores/uiStore'
import { WardLayerService } from '@/services/arcgis/WardLayerService'
// import { cacheService, CACHE_KEYS } from '@/services/CacheService'

function App() {
  useMobileDetection()
  useSelectionHistory()
  useSelectionPersistence()
  const setWards = useWardStore((state) => state.setWards)
  const setDataLoading = useUIStore((state) => state.setDataLoading)
  const wardLayerService = new WardLayerService()

  useEffect(() => {
    // Load ward data when MapService is initialized
    const loadWards = async () => {
      setDataLoading(true)
      try {
        // Check cache first
        // const cachedWards: WardInfo[] | null = cacheService.get(CACHE_KEYS.ALL_WARDS)
        // if (cachedWards) {
        //   console.log('Loading wards from cache')
        //   setWards(cachedWards)
        //   setDataLoading(false)
        //
        //   // Still query in background to refresh cache
        //   // MapService.waitForInitialization().then(async () => {
        //   //   const freshWards = await MapService.queryAllWards();
        //   //   cacheService.set(CACHE_KEYS.ALL_WARDS, freshWards);
        //   // });
        // } else {
          // No cache, load from service
          // await MapService.waitForInitialization();
          await wardLayerService.initialize(import.meta.env.VITE_FEATURE_SERVICE_URL!)
          const wards = await wardLayerService.queryWards()
          setWards(wards)

          // Cache the results
          // cacheService.set(CACHE_KEYS.ALL_WARDS, wards);
        // }
      } catch (error) {
        console.error('Error loading wards:', error)
      } finally {
        setDataLoading(false)
      }
    }

    loadWards()
  }, [setWards, setDataLoading])

  return <AppLayout />
}

export default App
